import { DeleteOutline } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import s from './DialogHeader.module.scss';

type DialogHeaderProps = {
  isEdit?: boolean;
  isCopy?: boolean;
  onDelete?: () => void;
};

export const DialogHeader: React.FC<DialogHeaderProps> = ({ isEdit, isCopy, onDelete }) => {
  const title = isEdit ? 'Изменение' : isCopy ? 'Дублирование' : 'Добавление';

  return (
    <div className={s.header}>
      <h1>{title} времени</h1>
      {isEdit && onDelete && (
        <Tooltip title="Удалить лог" arrow>
          <IconButton onClick={onDelete} size="small" sx={{ color: 'var(--danger-color)' }}>
            <DeleteOutline fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};
